import { useEffect, useRef, useState } from "react";
import { hexToRGB } from "../StyleInputs/CustomColorPicker";
import { rgbToHex } from "vagaro-website-rendering/src/components/Utilities/ColorMath";
import ColorInputField from "../StyleInputs/ColorInputField";
import { AttributeDefinition, AttributeInputType, AttributeTargetType } from "../Data/WBData";
import { AttributeCollection } from "vagaro-website-rendering/src/components/Definitions/LayoutNode";
import { ScreenSize } from "vagaro-website-rendering/src/components/Definitions/ScreenSize";
import { DefaultSiteData, SiteData } from "../Data/SiteData";
import XIcon from "vagaro-website-rendering/src/components/Icons/XIcon";


type GradientStop = {
    color: string;
    position: number;
}

enum GradientType {
    LINEAR,
    RADIAL,
    CONICAL


}

type GradientData = {

    type:GradientType;
    stops:GradientStop[];
    angle:number;
    centerX:number;
    centerY:number;
}


export default function GradientBuilder({onUpdateGradient,inGradient,useOpacity,siteData}:{siteData:SiteData,useOpacity?:boolean,inGradient?:string, onUpdateGradient:(gradientString:string)=>void}){


    const GetDefaultGradientFromString = ( gradientString:string):GradientData =>{

        let data = ConvertGradientStringToData(gradientString);
        if(data.stops.length<2){
            data.stops = [{color:"#000000",position:0},{color:"#ffffff",position:100}];
        }
        return data;

    }

    const inData = GetDefaultGradientFromString(inGradient?inGradient:"linear-gradient(90deg, #000000 0%, #ffffff 100%)");


    const [stops,setStops] = useState<GradientStop[]>(inData.stops);
    const [selectedStop,setSelectedStop] = useState<GradientStop|null>(null);
    const positionInput = useRef<HTMLInputElement>(null);
    const [angle,setAngle] = useState(inData.angle);
    const [gradientType,setGradientType] = useState<GradientType>(inData.type);
    const [xPos,setXPos] = useState(inData.centerX);
    const [yPos,setYPos] = useState(inData.centerY);

    const colorPickerDef = new AttributeDefinition("color","Color","",AttributeInputType.ColorField,[],null,AttributeTargetType.Component);
    const colorCollection = new AttributeCollection({},{color:selectedStop?selectedStop.color:"#000000"});

    const DeleteSelectedStop = ()=>{


        if(selectedStop){
            if(isNotFirstOrLastStop(stops,selectedStop)){

                let index = stops.findIndex((x)=>{
                    if(x.color == selectedStop.color&&x.position == selectedStop.position)
                        return true;
                    return false;

                });
                stops.splice(index,1);
                setStops([...stops]);
                setSelectedStop(null);
            }
        }




    }

    useEffect(()=>{
       let newGrad = ConvertGradientDataToString({type:gradientType,stops:stops,angle:angle,centerX:xPos,centerY:yPos});

        onUpdateGradient(newGrad);
//eslint-disable-next-line
    },[stops,gradientType,angle,xPos,yPos]);

    let clampPerc = (selectedStop?selectedStop.position:0);
    if(clampPerc<3)
        clampPerc = 3;
    if(clampPerc>97)
        clampPerc = 97;

    let canEditPos = selectedStop&&isNotFirstOrLastStop(stops,selectedStop);

    return <div className="w-full gradient-wrapper">
        <GradientStyling/>
        <div className="wb-input-group gradient">
        <div className="flex-row">
        <RenderStops siteData={siteData} defaultOpacity={(useOpacity?.4:1)} stops={stops} updateStops={setStops} setSelectedStop={setSelectedStop} selectedStop={selectedStop} positionInput={positionInput.current}/>
        </div>
        {selectedStop&&
            <div className="w-full stop-wrapper vanimation-fade-in no-delay">
                      <div className="w-full flex-row justify-end" style={{marginBottom:"4px"}}>
             <button style={{color:"#B42318",marginRight:"-12px",opacity:(canEditPos?"1":".5"),pointerEvents:(canEditPos?"all":"none")}}  className="delete-stop invisible-button" onClick={(e)=>{DeleteSelectedStop();}}><XIcon/></button></div>
            <ColorInputField key={(selectedStop?selectedStop.position:"none")} label="Color" definition={colorPickerDef} layoutObject={colorCollection} updateFunc={(att:string, val:string)=>{
            if(selectedStop){
                selectedStop.color = val;
                setStops([...stops]);
            }

        }} saveFunc={()=>{

        }}
        screenSize={ScreenSize.Desktop}
        siteData={DefaultSiteData}
        />

        <div className="wb-input-group justify-between flex-row w-full" style={(canEditPos)?{}:{opacity:".5",pointerEvents:"none"}}>

            <label>Position</label>
            <div className="type-input w-full">
            <input className="type-input perc range-text" ref={positionInput} type="number" min="0" max="100" defaultValue={selectedStop?.position}
                onInput={(e)=>{
                    let val = (e.target as any).value;
                    let num = parseFloat(val);
                    if(!isNaN(num)&&selectedStop&&num>=0&&num<=100){
                        selectedStop.position = num;
                        stops.sort((a,b)=>a.position-b.position);
                        setStops([...stops]);
                    }

                }}
            />
            </div>

        </div>


        <div style={{left:"calc(-7px + "+clampPerc+"%)"}} className="stop-caret"></div>
        </div>
    }

    <GradientTypePicker gradientType={gradientType} updateGradientType={setGradientType}/>
    {gradientType != GradientType.LINEAR&&
    <div className="w-full"><PositionField positionX={xPos} updatePositionX={setXPos} positionY={yPos} updatePositionY={setYPos}/></div>
    }
    {gradientType != GradientType.RADIAL&&
    <div className="w-full"><AngleInputField angle={angle} updateAngle={setAngle}/></div>
    }

      {/* <GradientPreview gradientString={previewString}/> */}
     </div>
     </div>


}

function ConvertGradientStringToData(gradientString: string): GradientData {

    let data:GradientData =  {
        type:GradientType.LINEAR,
        stops:[],
        angle:90,
        centerX:50,
        centerY:50
    }


    if(gradientString.includes("radial-gradient")){
        data.type = GradientType.RADIAL;
    }
    else if(gradientString.includes("conic-gradient")){
        data.type = GradientType.CONICAL;
    }
    else{
        data.type = GradientType.LINEAR;
    }

    let startIndex = gradientString.indexOf("(");
    let endIndex = gradientString.lastIndexOf(")");
    let gradientValues = gradientString.substring(startIndex+1,endIndex);
    let stringStops = gradientValues.split(",");


    for(let i = 0;i<stringStops.length;i++){



        let parse = stringStops[i].trim();

        if(i==0){

            // if(data.type === GradientType.LINEAR){

            // }
            if(parse.includes("deg")){
                let index = parse.indexOf("deg");
                let angle = parse.substring(0,index).replace("from","").trim();

                let angleNum = parseFloat(angle);
                if(!isNaN(angleNum))
                data.angle = angleNum;
            }
            if(parse.includes("at")){
                let index = parse.indexOf("at");
                let centering  = parse.substring(index).replaceAll("%","").trim();

                let centerSplit = centering.split(" ");
                if(centerSplit.length>1){
                    let x = parseFloat(centerSplit[1]);
                    let y = parseFloat(centerSplit[2]);

                    if(!isNaN(x)&&!isNaN(y)){
                        data.centerX = x;
                        data.centerY = y;
                    }
                }

            }

        }

        if(parse.startsWith("#")||parse.includes("var(")){
            let parseSplit = parse.split(" ");
            let color = parseSplit[0];
            let position = parseSplit[1].replace("%","");
            let num = parseFloat(position);
            if(!isNaN(num))
            data.stops.push({color:color,position:num});
        }
    }


    return data;
}

function ConvertGradientDataToString(data:GradientData):string{

    let gradientString = "";

    if(data.type === GradientType.LINEAR){
        gradientString += "linear-gradient(" + data.angle + "deg,";
    }
    else{
        if(data.type === GradientType.RADIAL){
            gradientString ="radial-gradient(circle at ";
        }
        else if(data.type === GradientType.CONICAL){
            gradientString ="conic-gradient(from "+data.angle+"deg at ";
        }

        gradientString +=data.centerX+"% "+data.centerY+"%,";
    }

    for(let i = 0;i<data.stops.length;i++){
        let stop = data.stops[i];
        gradientString += stop.color + " " + stop.position + "%";
        if(i<data.stops.length-1){
            gradientString += ",";
        }
    }

    gradientString += ")";

    return gradientString;

}

function isNotFirstOrLastStop(stops:GradientStop[],stop:GradientStop):boolean{
    let index = stops.findIndex((x)=>{
        if(x.color == stop.color&&x.position == stop.position)
            return true;
        return false;

    });

    return index>0&&index<stops.length-1;

}


function AddStop(stops:GradientStop[],newStop:GradientStop):GradientStop[]{

    newStop.position = Math.round(newStop.position);
    let newStops = [...stops,newStop];
    newStops.sort((a,b)=>a.position-b.position);
    return newStops;

}

function GradientStyling(){
   return <style>
    {
        `
        .gradient-wrapper .gradient{
            display:flex;
            flex-direction:column;

        }
        .gradient-wrapper .wb-input-group{
            border:none;
            margin:0;
            padding:8px 0;
        }

        .gradient-wrapper .g-mt{
            margin-top:16px;
        }
        .gradient-wrapper .wb-input-row{
            padding:0;
            margin:0;
        }

        .stop-wrapper .color-input-section{
            aling-items:center;
        }

        .stop-wrapper .color-button-container{
            width:38px;
        }


        .stop-wrapper label{
            margin:0;

            padding:0 !important;
            width:64px !important;
        }
        .stop-wrapper label::before{
            display:none;
        }

        .stop-wrapper input{
            width:100% !important;


        }

        .stop-wrapper .wb-input-group{
            display:flex;
            gap:8px;
            padding:0px;
            align-items:center;
        }

        .stop-wrapper{
            background:#e2e2e2;
            margin:12px 9px;
            width:calc(100% - 18px);
            border-radius:5px;
            padding:0 12px 12px 12px;
            position:relative;
            z-index:10;


            box-shadow:0 3px 8px 0 rgba(0,0,0,0.5);
        }

        .stop-wrapper .stop-caret{

            position:absolute;
            width:0;
            height:0;
            border-left:7px solid transparent;
            border-right:7px solid transparent;
            border-bottom:14px solid #e2e2e2;
            top:-10px;
        }

        .gradient-input-bar{
            height:30px;

            width:100%;
            position:relative;
            cursor:copy;
            -webkit-user-select: none;
            -khtml-user-select: none;
            -moz-user-select: none;
            -o-user-select: none;
            user-select: none;
        }



        .gradient-stop{
            position:absolute;
            width:10px;
            height:34px;
            top:-2px;
            cursor:pointer;
            z-index:1;
            border:1.5px solid black;
            outline:1px solid white;
            border-radius:5px;
            transition:transform 0.2s;
            box-shadow:0 0 4px 0 rgba(0,0,0,0.5);
        }

        .gradient-stop:hover, .gradient-stop.selected{
            transform:scale(1.1);
            z-index:2;
        }

        .gradient-stop.selected{
            outline:2px solid var(--input-selected-primary);
            border:1px solid white;
        }

        .gradient-stop:nth-child(1){
            z-index:0;
            border-radius:5px 0 0 5px;
        }

        .gradient-stop:last-child{

            border-radius:0 5px 5px 0;
            z-index:0;
        }

        .angle-radial{
            border:2px solid grey;
            width:36px;
            height:36px;
            background:#d2d2d2;
            border-radius:100%;
            flex-shrink:0;
            margin-right:4px;
            position:relative;
          }

          .angle-radial:focus, .angle-radial:active, .angle-radial:hover{
            border-color:var(--input-selected-primary);
          }

          .angle-radial::before{
            content:"";
            width:50%;
            position:absolute;
            top:calc(50% - 2px);
            height:4px;
            border-radius:2px;
            background:var(--input-selected-primary);
            left:50%;

          }

          .angle-radial::after{
            content:"";
            width:8px;
            position:absolute;
            top:calc(50% - 4px);
            height:8px;


            background:var(--input-selected-primary);
            right:-6px;
            border-radius:10px;


          }


          .gradient-editor-bg{


             margin:8px;



            background-image:
            -o-linear-gradient(45deg, #ccc 25%, transparent 25%),
            -o-linear-gradient(315deg, #ccc 25%, transparent 25%),
            -o-linear-gradient(45deg, transparent 75%, #ccc 75%),
            -o-linear-gradient(315deg, transparent 75%, #ccc 75%);


            background-image:

                linear-gradient(45deg, #ccc 25%, transparent 25%),
                linear-gradient(135deg, #ccc 25%, transparent 25%),
                linear-gradient(45deg, transparent 75%, #ccc 75%),
                linear-gradient(135deg, transparent 75%, #ccc 75%);
            background-size: 16px 16px;
            /* Must be a square */
            background-position: 0 0, 8px 0, 8px -8px, 0px 8px;
          }

          .gradient-preview > div{
            position:absolute;
            top:0;
            left:0;
          }

          .type-input{
            position:relative;
          }

          .type-input input{
            margin-left:0 !important;
            padding-right:24px;
          }
          .type-input.deg input{

            padding-right:36px;
          }

          .type-input::after{
            content:"%";

            display:block;
            top:6px;
            opacity:.75;
            position:absolute;
            pointer-events:none;
            right:8px;
            transition:right 0.2s;
          }


          .type-input.deg::after{
            content:"deg";
            right:6px;
          }

          @keyframes max-height-infinity {
            0% {
                max-height: 0px;
           }
            99% {
                max-height: 200px;
           }
            100% {
                max-height: 50000px;
           }
        }

        `
    }
</style>
}

function GradientTypePicker({gradientType,updateGradientType}:{gradientType:GradientType,updateGradientType:(type:GradientType)=>void}){

    return <>
    <label  className="g-mt">Gradient Type</label>
    <div className="wb-input-row flex-row">
        <button className={(gradientType==GradientType.LINEAR?"selected":"")} onClick={(e)=>{updateGradientType(GradientType.LINEAR)}}>Linear</button>
        <button className={(gradientType==GradientType.RADIAL?"selected":"")}onClick={(e)=>{updateGradientType(GradientType.RADIAL)}}>Radial</button>
        {/* <button className={(gradientType==GradientType.CONICAL?"selected":"")}onClick={(e)=>{updateGradientType(GradientType.CONICAL)}}>Conical</button> */}
    </div>
    </>

}

function AngleInputField({angle,updateAngle}:{angle:number,updateAngle:(angle:number)=>void}){

    const offset = 90;
    const angleRef = useRef<HTMLDivElement>(null);
    const inputRef = useRef<HTMLInputElement>(null);
    const startDrag = (e:any)=>{
        document.addEventListener("mousemove",drag);
        document.addEventListener("mouseup",endDrag);
        drag(e);

    }

    useEffect(()=>{

        return ()=>{
            document.removeEventListener("mousemove",drag);
            document.removeEventListener("mouseup",endDrag);
        }
        //eslint-disable-next-line
    },[]);

    const drag = (e:any)=>{
        let mouseX = e.clientX;
        let mouseY = e.clientY;
        let rect = angleRef.current!.getBoundingClientRect();
        let centerX = rect.left + rect.width/2;
        let centerY = rect.top + rect.height/2;
        let angle = Math.atan2(mouseY-centerY,mouseX-centerX);
        let degrees = angle*180/Math.PI +offset;
        if(degrees<0)
            degrees = 360+degrees;
        degrees = Math.round(degrees);
        if(inputRef.current){
            inputRef.current.value = degrees.toString();
        }
        updateAngle(degrees);

    }


    const endDrag = (e:any)=>{

        document.removeEventListener("mousemove",drag);
        document.removeEventListener("mouseup",endDrag);
    }

    return (
        <>
         <label className="g-mt">Angle</label>
        <div className="wb-input-row justify-between w-full gap-med">

        <div className="type-input deg w-full">
        <input className="w-full range-text  angle" ref={inputRef} type="number" min={-360} max={360} defaultValue={angle} onChange={(e)=>{
            let num = parseFloat(e.target.value);
            if(!isNaN(num))
            updateAngle(num);
        }}/>
        </div>

            <div
            style={{transform:"rotateZ("+(angle-offset)+"deg)"}}
                onMouseDown={(e)=>{startDrag(e)}}
                ref={angleRef} className="angle-radial">
            </div>

        </div>
        </>
    )


}

function PositionField({positionX,updatePositionX,positionY,updatePositionY}:{positionX:number,updatePositionX:(position:number)=>void,positionY:number,updatePositionY:(position:number)=>void}){

    return (
        <>
        <label className="g-mt">Center</label>
       <div className="wb-input-row justify-between w-full gap-med">
       <div>X:</div>
       <div className="type-input w-full">

       <input className="w-full range-text "  type="number" min={0} max={100} defaultValue={positionX} onChange={(e)=>{
           let num = parseFloat(e.target.value);
           if(!isNaN(num))
           updatePositionX(num);
       }}/>
       </div>
       <div>Y:</div>
       <div className="type-input w-full">
       <input className="w-full range-text "  type="number" min={0} max={100} defaultValue={positionY} onChange={(e)=>{
           let num = parseFloat(e.target.value);
           if(!isNaN(num))
           updatePositionY(num);
       }}/>
       </div>

       </div>
       </>
    )

}

// function GradientPreview({gradientString}:{gradientString:string}){

//     return <div  className="gradient-preview g-mt"> <div className="w-full h-full" style={{backgroundImage:gradientString}}></div></div>

// }

function RenderStops({siteData,stops,updateStops,setSelectedStop,selectedStop,positionInput,defaultOpacity}:{siteData:SiteData,defaultOpacity:number,stops:GradientStop[],updateStops:(stops:GradientStop[])=>void,setSelectedStop:(stop:GradientStop)=>void,selectedStop:GradientStop|null,positionInput:HTMLInputElement|null}){

    const barRef = useRef<HTMLDivElement>(null);
    const draggedStop = useRef<GradientStop|null>(null);
    let gradientString = ConvertGradientDataToString({type:GradientType.LINEAR,stops:stops,angle:90,centerX:50,centerY:50});


    useEffect(()=>{

        return ()=>{
            document.removeEventListener("mousemove",Drag);
            document.removeEventListener("mouseup",EndDrag);
        }
//eslint-disable-next-line
    },[]);


    const StartDrag = (e:any)=>{


        document.addEventListener("mousemove",Drag);
        document.addEventListener("mouseup",EndDrag);
    }

    const Drag = (e:any)=>{

        let pos = e.clientX;
        let offset = pos -barRef.current!.getBoundingClientRect().left;
        let percent = (offset/barRef.current!.clientWidth)*100;
        if(percent<0)
        percent = 0;
        if(percent>100)
        percent = 100;

        percent = Math.round(percent);

        if(draggedStop.current){
            draggedStop.current.position = percent;
            stops.sort((a,b)=>a.position-b.position);
            updateStops([...stops]);
            if(positionInput){
                positionInput.value = percent.toString();
            }
        }
    }
    const EndDrag = (e:any)=>{
        document.removeEventListener("mousemove",Drag);
        document.removeEventListener("mouseup",EndDrag);
    }

    return (
        <div className="gradient-editor-bg w-full">
        <div ref={barRef}
        style={{backgroundImage:gradientString}}
        onMouseDown={(e)=>{

            let pos = e.clientX - barRef.current!.getBoundingClientRect().left;
            let percent = (pos/barRef.current!.clientWidth)*100;

            let lastColor = "#000000";
            let lastPerc = 0;
            let nextColor = "#ffffff";
            let nextPerc = 100;
            for(let i = 0;i<stops.length;i++){
                let stop = stops[i];
                if(stop.position<percent){
                    lastColor = stop.color;
                    lastPerc = stop.position;

                }
                else{
                    nextColor = stop.color;
                    nextPerc = stop.position;
                    break;
                }

            }
            let hex = ( percent-lastPerc<nextPerc-percent )?lastColor:nextColor;


            //parse pallet colors into hex vals
            let hexCodes = [lastColor,nextColor];
            for(let i = 0;i<hexCodes.length;i++){
                let cd = hexCodes[i];

                if(cd.startsWith("var(")){

                    let colorVar = cd.replace("var(--theme-color-","").replace(")","");
                    let color = siteData.siteStyling.colorPallet[parseInt(colorVar)-1];
                    hexCodes[i] = color;
                }

            }
            lastColor = hexCodes[0];
            nextColor = hexCodes[1];

            if(lastColor.startsWith("#")&&nextColor.startsWith("#")){
                let colorA = hexToRGB(lastColor);
                let colorB = hexToRGB(nextColor);

                let percentA = (percent-lastPerc)/(nextPerc-lastPerc);
                let  r = colorA.r + (colorB.r-colorA.r)*percentA;
                let g =  colorA.g + (colorB.g-colorA.g)*percentA;
                let b =  colorA.b + (colorB.b-colorA.b)*percentA;
                let a = defaultOpacity;

                hex =rgbToHex(r,g,b,a);
            }
            let newStop = {color:hex,position:percent};

            updateStops(AddStop(stops,newStop));
            setSelectedStop(newStop);



            if(positionInput){
                positionInput.value = newStop.position.toString();
            }

        }}

        className="gradient-input-bar">
            {
            stops.map((stop,index)=>{

                let style:any = {backgroundColor:stop.color,left:"calc(-5px + "+stop.position+"%)"};

                return (
                    <div className={"gradient-stop" + (stop === selectedStop? " selected":"") }
                    style={style}
                    key={index}
                    onMouseDown={(e)=>{
                        e.stopPropagation();
                        setSelectedStop(stop);
                        if(positionInput){
                            positionInput.value = stop.position.toString();
                        }
                        draggedStop.current = stop;
                        if(index>0&&index<stops.length-1)
                            StartDrag(e);
                    }}
                    >
                    </div>
                )
            })}
        </div>
        </div>
    )

}